import { UserRegionUpdatableInterface } from '../interfaces/user-region-updatable.interface';
import { UserRegionDto } from './user-region.dto';
import { PartialType, PickType } from '@nestjs/swagger';

export class UserRegionUpdateDto
  extends PartialType(PickType(UserRegionDto, ['managerUserId']))
  implements UserRegionUpdatableInterface {}
